export interface NavItem {
  label: string
  path: string
}

export const navItems: NavItem[] = [
  { label: 'nav.home', path: '/' },
  { label: 'nav.features', path: '/features' },
  { label: 'nav.who', path: '/who' },
  { label: 'nav.integrations', path: '/integrations' },
  { label: 'nav.pricing', path: '/pricing' },
  { label: 'nav.howItWorks', path: '/how-it-works' },
  { label: 'nav.contact', path: '/contact' }
]